import { render } from "./MbBt.vue?vue&type=template&id=133e33d4&scoped=true"
import script from "./MbBt.vue?vue&type=script&lang=js"
export * from "./MbBt.vue?vue&type=script&lang=js"

import "./MbBt.vue?vue&type=style&index=0&id=133e33d4&scoped=true&lang=css"

import exportComponent from "D:\\Students\\서용석\\vuestudy\\vuegeoje\\vuegeoje\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133e33d4"]])

export default __exports__